<template>
  <h3 class="p-6 text-lg font-semibold text-[#f8f7f2]">
    Tecnologias e Ferramentas
  </h3>

  <div class="flex flex-wrap justify-start">
    <div
      v-for="tecnologia in tecnologias"
      :key="tecnologia.id"
      class="flex items-center justify-center"
    >
      <img :src="tecnologia.img" class="w-14 h-14 m-4" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tecnologias: [
        {
          img: require("@/assets/html.png"),
        },
        {
          img: require("@/assets/css.png"),
        },
        {
          img: require("@/assets/tailwind.png"),
        },
        {
          img: require("@/assets/javascript.png"),
        },
        {
          img: require("@/assets/vue.png"),
        },
        {
          img: require("@/assets/vuetify.png"),
        },
        {
          img: require("@/assets/nodejs.png"),
        },
        {
          img: require("@/assets/express.png"),
        },
        {
          img: require("@/assets/python.png"),
        },
        {
          img: require("@/assets/django.png"),
        },
        {
          img: require("@/assets/mongo.png"),
        },
        {
          img: require("@/assets/mysql.png"),
        },
        {
          img: require("@/assets/linux.png"),
        },
        {
          img: require("@/assets/git.png"),
        },
        {
          img: require("@/assets/vscode.png"),
        },
      ],
    };
  },
};
</script>

<style>
</style>